<template>
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Quản lý quỹ xu"
            :link="[
              {
                text: 'Quỹ xu',
                href: '../balance'
              }
            ]"
          ></Breadcrumbs>
        </div>
      </div>
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StudentFilter ref="student-filter" @onFilterChanged="filterStudent" />
    </v-card>
    <div class="mx-4">
      <CreditTable />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentFilter from '../../modules/student/StudentFilter.vue'
import CreditTable from '../../modules/studentCredit/CreditTable.vue'
import { mapActions } from 'vuex'
export default {
  components: { Breadcrumbs, StudentFilter, CreditTable },
  async created() {
    try {
      this.setLoading(true)
      await this.find({ _start: 0, _limit: 10 })
      await this.count()
    } finally {
      this.setLoading(false)
    }
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    ...mapActions({
      find: 'studentCredit/fetch',
      count: 'studentCredit/fetchCount',
      setFilter: 'studentCredit/setFilter',
      setLoading: 'studentCredit/setLoading'
    }),
    async filterStudent(data) {
      this.setLoading(true)
      try {
        const keys = Object.keys(data)
        let dataFilter = {}
        keys.forEach(item => {
          if (data[item]) dataFilter[item] = data[item]
        })
        this.setFilter(dataFilter)
        await this.find({ ...dataFilter, _start: 0, _limit: 10 })
        await this.count({ ...dataFilter })
      } catch (error) {
      } finally {
        this.setLoading(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter {
  border: 1px solid;
}
</style>
